<template>
    <div>
        <v-container grid-list-xl fluid>
            <header-title title="Registro"></header-title>
            <div v-if="convocatoria.id > 0">
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-text>
                                <b>POSTULACIÓN AL PROGRAMA INGLÉS PARA TODOS - GESTIÓN 2026</b>.
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="mb-1">
                    <v-col cols="12" sm="8" class="offset-2" v-for="(item, index) in modalidades" :key="index">
                        <v-card>
                            <v-card-title>ASPECTOS GENERALES</v-card-title>
                            <v-card-text>
                                <div>
                                    <p class="mt-2" v-if="item.sigla == 'A'">
                                    <ul>
                                        <li>
                                            El Ministerio de Educación del Estado Plurinacional de
                                            Bolivia, en coordinación con la Embajada de Estados Unidos
                                            en Bolivia, en el marco de la Constitución Política del Estado,
                                            la Ley Nº 070 del 20 de diciembre de 2010 “Avelino Siñani -
                                            Elizardo Pérez” y el Reglamento del Proceso de Selección
                                            al Programa Inglés para Todos convoca a estudiantes y
                                            bachilleres de unidades educativas fiscales y de convenio a
                                            participar en el Programa Inglés para Todos, en el marco de
                                            la cooperación interinstitucional y conforme a la normativa
                                            vigente.
                                        </li>
                                        <li>
                                            Al finalizar el llenado del Formulario de Postulación, y
                                            antes de guardarlo e imprimirlo, el postulante deberá
                                            verificar que todos los datos proporcionados sean
                                            correctos. Los errores u omisiones serán de su entera
                                            responsabilidad. Una vez recibido el formulario, los
                                            datos erróneos no podrán ser modificados.
                                        </li>
                                    </ul>
                                    </p>

                                </div>

                                <div class="text-center">
                                    <v-btn type="submit" color="primary" @click="selectModalidad(item.id, item.sigla)">
                                        Postular
                                    </v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
            <div v-else>
                <notify-card :title="notify_title" :load="notify_load" process="el proceso de admisión"></notify-card>
            </div>
        </v-container>
    </div>
</template>

<script>
import HeaderTitle from "@/components/HeaderTitle";
import NotifyCard from "@/components/NotifyCard";
import Service from "../utils/general";
import axios from "axios";

export default {
    name: "admision-inscripcion",
    components: {
        HeaderTitle,
        NotifyCard,
    },
    data: () => ({
        notify_title: "Cargando",
        notify_load: true,
        convocatoria: {
            id: null,
            cite: ""
        },
        modalidades: [],
    }),
    mounted() {
        this.getModalidades();
        Service.removeModality();
    },
    methods: {
        getModalidades() {
            this.notify_load = true;
            axios
                .get(
                    Service.getUrlAPI() + "admision/modalidad",
                    Service.getHeader()
                )
                .then(response => {
                    this.convocatoria = response.data.convocatoria ? response.data.convocatoria : { id: null, cite: "" };
                    this.modalidades = response.data.modalidades;
                    this.notify_title = "Notificación";
                    this.notify_load = false;
                })
                .catch(() => {
                    this.notify_load = false;
                    console.error("Parametros no encontrado");
                });
        },

        selectModalidad(id, sigla) {
            Service.setModality(this.convocatoria.id + '|' + id + '|' + sigla);
            if (sigla === 'A') {
                this.$router.push({ name: "admision-registro-a" });
            } else {
                this.$router.push({ name: "admision-registro-b" });
            }
        },
    },
};
</script>